"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var areaUnits_1 = require("./areaUnits");
var densityUnits_1 = require("./densityUnits");
var lengthUnits_1 = require("./lengthUnits");
var massAndWeightUnits_1 = require("./massAndWeightUnits");
var powerUnits_1 = require("./powerUnits");
var pressureUnits_1 = require("./pressureUnits");
var timeUnits_1 = require("./timeUnits");
var volumeUnits_1 = require("./volumeUnits");
exports.getResourceUnits = function (measure) {
    var units = {
        area: areaUnits_1.areaUnits,
        density: densityUnits_1.densityUnits,
        length: lengthUnits_1.lengthUnits,
        massandweight: massAndWeightUnits_1.massAndWeightUnits,
        power: powerUnits_1.powerUnits,
        pressure: pressureUnits_1.pressureUnits,
        time: timeUnits_1.timeUnits,
        volume: volumeUnits_1.volumeUnits
    };
    return units[measure];
};
